export const PDF_CONTENT_LOADED_CBNAME = 'pdfContentLoaded';
export const DEFAULT_SCHOOL_LEVELS = Array.from({ length: 14 }, (_, i) => i);
export const AUTOMATIC_DELETION_DAYS = 14;
